export default {
  // Dialog Titles
  saveCanvas: "Save Canvas",
  addNewCaseAndSaveCanvas: "Add New Case and Save Canvas",

  // Form Labels
  canvasName: "Canvas Name",
  relatedCase: "Related Case",
  canvasDescription: "Canvas Description",
  caseName: "Case Name",
  caseType: "Case Type",
  caseTypeName: "Case Type Name",
  caseDescription: "Case Description",

  // Placeholders
  pleaseEnterCanvasName: "Please enter canvas name (required)",
  selectOrSearchCase: "Please select or search case",
  pleaseEnterCanvasDescription:
    "Please enter canvas description (within 200 characters)",
  pleaseEnterCaseName: "Please enter case name (required)",
  pleaseSelectCaseType: "Please select case type (required)",
  pleaseSelectCaseTypeName: "Please select case type name",
  pleaseEnterCaseDescription: "Please enter case description",

  // Buttons
  cancel: "Cancel",
  confirm: "Confirm",
  saveCaseAndCanvas: "Save Case & Canvas",
  addNewCase: "Add New Case",

  // Section Titles
  canvasInfo: "Canvas Information",
  addNewCaseTitle: "Add New Case",

  // Validation Messages
  canvasNameRequired: "Canvas name is required",
  caseRequired: "Case is required",
  caseNameRequired: "Case name is required",
  caseNameLength: "Length should be 1 to 20 characters",
  pleaseSelectCaseTypeValidation: "Please select case type",
  caseDescriptionLength: "Length should be 1 to 200 characters",

  // Success Messages
  saveSuccess: "Saved successfully",

  // Canvas Types
  singleCurrencyCanvas: "Single Currency Canvas",
  multiCurrencyCanvas: "Multi Currency Canvas",
};
